import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import Field from "../Field";

interface ManualGameDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  gameName: string;
  setGameName: (value: string) => void;
  loading: boolean;
  onCreate: () => void;
}

const ManualGameDialog: React.FC<ManualGameDialogProps> = ({
  open,
  onOpenChange,
  gameName,
  setGameName,
  loading,
  onCreate,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md">
      <DialogHeader>
        <DialogTitle>Oyun cədvəli yarat</DialogTitle>
      </DialogHeader>
      <div className="space-y-3">
        <Field label="Oyunun adı">
          <Input
            placeholder="Məs: Dostlar arası quiz"
            value={gameName}
            onChange={(e) => setGameName(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && onCreate()}
          />
        </Field>
        <Button onClick={onCreate} disabled={loading} className="w-full">
          Yarat
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);

export default ManualGameDialog;
